import { useSelector, useDispatch } from 'react-redux'
import { formatCurrencyAlwaysSign } from '../../utils/money'
import { t } from '../../utils/i18n'
import { checkLack, getChoice } from '../../utils/bike-config'
import InitialsField from '../InitialsField'
import Popover from '../Popover'
import { bikeImageReload, optionClicked } from '../../actions'
import { BACKEND_URL, isDk, isEu, isDe } from '../../utils/settings'

const ComponentTogglePopover = () => {
  const dispatch = useDispatch()
  const components = useSelector((state) => state.components)
  const bikeConfig = useSelector((state) => state.bikeConfig)
  const lang = useSelector((state) => state.lang)
  const currencyCode = useSelector((state) => state.currencyCode)

  const getNationalizedProductUrl = (option) => {
    if (
      option.id === 'tracker' ||
      option.id === 'silver-holder' ||
      option.id === 'velorbis-edrive-battery-frame-black' ||
      option.id === 'velorbis-edrive-battery-frame-brown'
    ) {
      if (isEu) return option.product_eu
      if (isDk) return option.product_dk
      if (isDe) return option.product_de
      else return option.product // fallback value
    } else return option.product
  }

  const componentList = components
    .map((component) => {
      const choice = getChoice(bikeConfig, component)
      const options = component.options
      // TODO: refactor this to use the choice object
      const currentPrice = choice.option.price
        ? choice.option.prices[currencyCode]
        : 0
      return {
        name: component.name[lang],
        id: component.id,
        price:
          (options[1].price ? options[1].prices[currencyCode] : 0) -
          currentPrice,
        sold: options[1].sold,
        product: getNationalizedProductUrl(options[1]),
        optionId: options[1].id,
        prompt: component.prompt,
        optionList: options,
        choice,
        hide_price: component.hide_price
      }
    })
    .filter((el) => el != null)

  const handleOn = (component, id) => {
    dispatch(optionClicked(component, id, true))
    dispatch(bikeImageReload())
  }

  const handleOff = (component) => {
    dispatch(optionClicked(component, 'off', true))
    dispatch(bikeImageReload())
  }

  return (
    <Popover
      className="velorbis-customizer-color-picker"
      minWidth={'250px'}
      maxWidth={'97%'}
      alignTo={'.velorbis-toggle-component'}
    >
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-scorll velorbis-customizer-hover-popover">
        {componentList.map((component) => {
          const isLack = checkLack(component.prompt, component.optionList)

          const isMulti =
            component.id === 'skirt-guard' || component.id === 'basket-cover'
          const BasketCover = component.id === 'basket-cover' && (
            <div className="velorbis-customizer-toggleable-skirt-buttons">
              {component.choice.option.id !== 'basket-cover-black' && (
                <button
                  className="velorbis-customizer-toggleable-black"
                  onClick={() => handleOn(component.id, 'basket-cover-black')}
                >
                  {t('color_black')}
                </button>
              )}
              {component.choice.option.id !== 'basket-cover-white' && (
                <button
                  className="velorbis-customizer-toggleable-cream"
                  onClick={() => handleOn(component.id, 'basket-cover-white')}
                >
                  {t('color_cream')}
                </button>
              )}
              {component.choice.option.id !== 'off' && (
                <button
                  className="velorbis-customizer-toggleable-off"
                  onClick={() => handleOff(component.id)}
                >
                  {t('toggle_off')}
                </button>
              )}
            </div>
          )
          const SkirtGuard = component.id === 'skirt-guard' && (
            <div className="velorbis-customizer-toggleable-skirt-buttons">
              {component.choice.option.id !== 'black' && (
                <button
                  className="velorbis-customizer-toggleable-black"
                  onClick={() => handleOn(component.id, 'black')}
                >
                  {t('color_black')}
                </button>
              )}
              {component.choice.option.id !== 'brown' && (
                <button
                  className="velorbis-customizer-toggleable-brown"
                  onClick={() => handleOn(component.id, 'brown')}
                >
                  {t('color_brown')}
                </button>
              )}
              {component.choice.option.id !== 'off' && (
                <button
                  className="velorbis-customizer-toggleable-off"
                  onClick={() => handleOff(component.id)}
                >
                  {t('toggle_off')}
                </button>
              )}
            </div>
          )
          const isSaddleInput =
            component.id === 'name-plate' &&
            component.choice.option.id !== 'off'
          return (
            <div
              className="velorbis-customizer-hover-popover-item-wrapper"
              key={component.id}
            >
              <div
                className={`velorbis-customizer-toggle-popover-item ${
                  component.sold
                    ? 'velorbis-customizer-hover-popover-item-sold'
                    : ''
                }`}
              >
                <div className="velorbis-customizer-hover-popover-item-title">
                  {component.name}
                </div>
                <div className="velorbis-customizer-hover-popover-item-content">
                  {isLack ? (
                    <div className="velorbis-customizer-toggleable-prompt">
                      {t(`${component.id}_prompt`)}
                    </div>
                  ) : (
                    <>
                      {SkirtGuard}
                      {BasketCover}
                      {!isMulti && (
                        <div className="velorbis-customizer-toggleable-buttons">
                          {component.choice.option.id === 'off' ? (
                            <button
                              className="velorbis-customizer-toggleable-on"
                              onClick={() =>
                                handleOn(component.id, component.optionId)
                              }
                            >
                              {t('toggle_on')}
                            </button>
                          ) : (
                            <button
                              className="velorbis-customizer-toggleable-off"
                              onClick={() => handleOff(component.id)}
                            >
                              {t('toggle_off')}
                            </button>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  <img
                    className="velorbis-customizer-hover-popover-image"
                    src={`${BACKEND_URL}/images/thumbnails/${component.id}/${component.optionId}.png`}
                    alt={component.name}
                  />
                  {component.sold ? (
                    <div className="velorbis-customizer-sold-out">
                      Sold out!
                    </div>
                  ) : (
                    <div>
                      {!component.hide_price &&
                        formatCurrencyAlwaysSign(component.price, currencyCode)}
                    </div>
                  )}
                </div>
              </div>
              {isSaddleInput && (
                <div>
                  <InitialsField />
                </div>
              )}
              {component.product && (
                <a
                  className="product-link"
                  href={component.product}
                  rel="noreferrer"
                  target="_blank"
                >
                  {t('add_product_link')}
                </a>
              )}
            </div>
          )
        })}
      </div>
    </Popover>
  )
}

export default ComponentTogglePopover
